import React from "react";
import PropTypes from "prop-types";

const Table = ({ resultados, onOpenModal, reintentarEnvio }) => {
  if (!resultados) {
    return <div>No hay datos disponibles</div>;
  }

  const mostrarBotones = resultados.estado !== "procesando";

  return (
    <div className="tabla-responsiva">
      <table>
        <thead>
          <tr>
            <th>Nombre Archivo</th>
            <th>Estado</th>
            <th>Fecha</th>
            <th>RUT Persona</th>
            <th>RUT Empresa</th>
          </tr>
        </thead>
        <tbody>
          {resultados.estado === "error" ? (
            <tr>
              <td colSpan="5">
                Error al procesar archivo {resultados.archivoName}:{" "}
                {resultados.mensajeError}
                <span className="icono-error">&#10060;</span>
              </td>
            </tr>
          ) : resultados.estado === "reintentando" ? (
            <tr>
              <td colSpan="5">
                Reintentando archivo {resultados.archivoName}...
                <span className="icono-actualizando">&#8635;</span>
              </td>
            </tr>
          ) : resultados.estado === "procesando" ? (
            <tr>
              <td colSpan="5">
                Procesando archivo {resultados.archivoName}...
                <span className="icono-actualizando"></span>
              </td>
            </tr>
          ) : (
            <tr>
              <td data-label="Nombre Archivo">
                {resultados.archivoName || "Cargando..."}
              </td>
              <td data-label="Estado">
                {resultados.estado === "Listo" && (
                  <>
                    Listo
                    <span className="icono-check">&#10003;</span>
                  </>
                )}
                {resultados.estado === "error" && (
                  <>
                    Error
                    <span className="icono-error">&#10060;</span>
                  </>
                )}
              </td>
              <td data-label="Fecha">{resultados.FECHA || ""}</td>
              <td data-label="RUT Persona">{resultados.RUT_PERSONA || ""}</td>
              <td data-label="RUT Empresa">{resultados.RUT_EMPRESA || ""}</td>
            </tr>
          )}
          {mostrarBotones && (
            <tr>
              <td colSpan="5">
                <button onClick={() => reintentarEnvio(resultados.archivoName)}>
                  Reintentar
                </button>
                <button onClick={() => onOpenModal(resultados, "pdf")}>
                  Ver Archivo
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  resultados: PropTypes.shape({
    archivoName: PropTypes.string.isRequired,
    estado: PropTypes.string.isRequired,
    FECHA: PropTypes.string,
    RUT_PERSONA: PropTypes.string,
    RUT_EMPRESA: PropTypes.string,
    mensajeError: PropTypes.string,
  }).isRequired,
  reintentarEnvio: PropTypes.func.isRequired,
  onOpenModal: PropTypes.func.isRequired,
};

export default Table;
